const initialMessageState = {
    clientDataReducer: false,
    clientPathReducer: false,
    FileDataReducer: false,
    FileMetaDataCategoryReducer: false,
    FileReducer: false,
    FileTypeReducer: false,
    FrontEndUserReducer: false,
    ProductReducer: false,
    UserReducer: false,
    EditingInProgress: false
}

export const LoaderReducer = (state = initialMessageState, action = {}) => {

    switch (action.type) {
        case 'SET_LOADING_STATUS':
            
            return {
                ...state,
                [action.payload.reducer] : action.payload.status
            }
        case 'EDITING_IN_PROGRESS':
            return {
              ...state,
              EditingInProgress: action.status         
            }     

        case 'USER_LOGOUT':
        case 'USER_INACTIVE':
            return initialMessageState
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/LoaderReducer.js